const uploadUrl = process.env.REACT_APP_STATIC_URL;

const useUploadedFile = (filename) => {
  if (!filename) return null;

  return `${uploadUrl}/${filename}`;
};
export default useUploadedFile;
